import bnLcvRouteLanding from "../../../core/src/locales/bn/lcvRouteLanding.json";
import enLcvRouteLanding from "../../../core/src/locales/en/lcvRouteLanding.json";
import guLcvRouteLanding from "../../../core/src/locales/gu/lcvRouteLanding.json";
import hiLcvRouteLanding from "../../../core/src/locales/hi/lcvRouteLanding.json";
import knLcvRouteLanding from "../../../core/src/locales/kn/lcvRouteLanding.json";
import mrLcvRouteLanding from "../../../core/src/locales/mr/lcvRouteLanding.json";
import taLcvRouteLanding from "../../../core/src/locales/ta/lcvRouteLanding.json";
import teLcvRouteLanding from "../../../core/src/locales/te/lcvRouteLanding.json";

import { getCityPageBySlug, getCityPagePath, getCityPageSlugs } from "./data";

const CITY_LABELS_BY_LOCALE: Record<string, Record<string, string>> = {
    bn: Object.fromEntries(
        Object.entries(
            (bnLcvRouteLanding as { cities?: Record<string, { breadcrumbCityName?: string }> }).cities ?? {}
        ).map(([slug, city]) => [slug, city.breadcrumbCityName ?? slug])
    ),
    en: Object.fromEntries(
        Object.entries(
            (enLcvRouteLanding as { cities?: Record<string, { breadcrumbCityName?: string }> }).cities ?? {}
        ).map(([slug, city]) => [slug, city.breadcrumbCityName ?? slug])
    ),
    gu: Object.fromEntries(
        Object.entries(
            (guLcvRouteLanding as { cities?: Record<string, { breadcrumbCityName?: string }> }).cities ?? {}
        ).map(([slug, city]) => [slug, city.breadcrumbCityName ?? slug])
    ),
    hi: Object.fromEntries(
        Object.entries(
            (hiLcvRouteLanding as { cities?: Record<string, { breadcrumbCityName?: string }> }).cities ?? {}
        ).map(([slug, city]) => [slug, city.breadcrumbCityName ?? slug])
    ),
    kn: Object.fromEntries(
        Object.entries(
            (knLcvRouteLanding as { cities?: Record<string, { breadcrumbCityName?: string }> }).cities ?? {}
        ).map(([slug, city]) => [slug, city.breadcrumbCityName ?? slug])
    ),
    mr: Object.fromEntries(
        Object.entries(
            (mrLcvRouteLanding as { cities?: Record<string, { breadcrumbCityName?: string }> }).cities ?? {}
        ).map(([slug, city]) => [slug, city.breadcrumbCityName ?? slug])
    ),
    ta: Object.fromEntries(
        Object.entries(
            (taLcvRouteLanding as { cities?: Record<string, { breadcrumbCityName?: string }> }).cities ?? {}
        ).map(([slug, city]) => [slug, city.breadcrumbCityName ?? slug])
    ),
    te: Object.fromEntries(
        Object.entries(
            (teLcvRouteLanding as { cities?: Record<string, { breadcrumbCityName?: string }> }).cities ?? {}
        ).map(([slug, city]) => [slug, city.breadcrumbCityName ?? slug])
    )
};

export interface CityFooterAlternateLink {
    locale: string;
    label: string;
    path: string;
}

export interface CityFooterLinkGroup {
    slug: string;
    alternates: CityFooterAlternateLink[];
}

export const getCityPageLocalizedPath = (locale: string, slug: string) => {
    const basePath = getCityPagePath(slug);
    return locale === "en" ? basePath : `/${locale}${basePath}`;
};

const getCityPageLabel = (locale: string, slug: string) =>
    CITY_LABELS_BY_LOCALE[locale]?.[slug] ?? CITY_LABELS_BY_LOCALE.en[slug] ?? slug;

export const getCityPageFooterLinkGroups = (): CityFooterLinkGroup[] =>
    getCityPageSlugs().map((slug) => {
        const locales = getCityPageBySlug(slug)?.hreflangLocales ?? ["en"];

        return {
            slug,
            alternates: locales.map((locale) => ({
                locale,
                label: getCityPageLabel(locale, slug),
                path: getCityPageLocalizedPath(locale, slug)
            }))
        };
    });
